export default __webpack_public_path__ + "static/media/microphone.0cc032d5.svg";